import cn from 'classnames';
import CTA from 'react-scale/components/elements/cta';

const Banner = ({ overtitle, title, product, subtitle, cta, children, inverted, spacing }) => (
  <div
    className={cn(
      inverted && 'flex-row-reverse',
      'flex flex-wrap-reverse items-center gap-12 px-10 py-10 xl:py-18 bg-neutral-900 md:px-20 xl:gap-10 md:flex-nowrap rounded-3xl',
      { 'xl:gap-10': spacing === 'sm' },
      { 'xl:gap-24': spacing === 'md' }
    )}
  >
    <div className="w-full md:w-7/12">
      {overtitle && (
        <h4 className="inline-block mb-4 text-overtitle-sm text-gradient">{overtitle}</h4>
      )}
      <h1
        className={cn(
          'w-3/4 mb-6 text-2xl font-normal text-white font-aeonik',
          overtitle || !product ? 'md:text-4xl' : 'md:text-5xl md:font-light'
        )}
      >
        {title}{' '}
        {product && (
          <span className="font-normal md:font-light text-transform-gradient box-decoration-clone">
            {product}
          </span>
        )}
      </h1>
      <p className="mb-10 text-base leading-8 text-white md:mb-8 xl:text-lg">{subtitle}</p>
      <div className="xl:w-5/6">
        <CTA cta={cta} />
      </div>
    </div>
    <div className="w-full md:w-5/12">{children}</div>
  </div>
);

export default Banner;
